
const digest = '7d5d239771cbf65bcdb7b62d6e80be8c2f2689c9da04fa4085689cd25f20d970';
const classes = {"hintText":"_hintText_1m4e4_1"};
const css = `._hintText_1m4e4_1 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  